import { requireSupabase } from '../lib/supabase';

async function invoke(name, body) {
  const { data, error } = await requireSupabase().functions.invoke(name, { body });
  if (error) throw error;
  if (!data?.url) throw new Error('No se recibió una URL de Stripe.');
  window.location.assign(data.url);
}

export function startCheckout({
  planKey,
  billingInterval,
  scope,
  seatQuantity = 1,
  successPath = '/licencias?checkout=success',
}) {
  return invoke('stripe-checkout', {
    planKey,
    billingInterval,
    scope: scope === 'club' ? 'organization' : scope,
    seatQuantity,
    successUrl: `${window.location.origin}${successPath}`,
    cancelUrl: window.location.href,
  });
}

export function openBillingPortal({ returnPath = '/licencias' } = {}) {
  return invoke('stripe-portal', { returnUrl: `${window.location.origin}${returnPath}` });
}
